// extracted by mini-css-extract-plugin
export default {"addToCartControl":"g2-z","giftCard":"h2-z","btnContainer":"i2-z","cartButton":"j2-z","disabled":"k2-z"};